import { Inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SsrReplaceService {
  public constructor(@Inject(DOCUMENT) private readonly _doc: Document) {}

  public getWindow(): Window | null {
    return this._doc.defaultView;
  }

  public getLocation(): Location {
    return this._doc.location;
  }

  public createElement(tag: string): HTMLElement {
    return this._doc.createElement(tag);
  }
}
